import { ApiService } from '@abb-procure/api';
import { Injectable } from '@angular/core';
import { boolean as ioBoolean } from 'io-ts';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApplicationNotification } from '../types/application-notification.type';

@Injectable({
  providedIn: 'root',
})
export class GlobalNotificationApiService extends ApiService {
  readonly notificationUpdated$: Observable<ApplicationNotification | null>;

  private notificationUpdatedSubject$: BehaviorSubject<ApplicationNotification | null> =
    new BehaviorSubject(null);

  constructor() {
    super();

    this.notificationUpdated$ = this.notificationUpdatedSubject$.asObservable();
  }

  async getNotification(): Promise<ApplicationNotification | null> {
    try {
      return this.get<ApplicationNotification>(
        'Management/Notification',
        ApplicationNotification,
      );
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue while retrieving the notification data.',
      );
    }
  }

  async updateNotification(
    notification: ApplicationNotification,
  ): Promise<ApplicationNotification | null> {
    try {
      await this.put<boolean | null, ApplicationNotification>(
        'Management/Notification',
        ioBoolean,
        notification,
      );

      const response = await this.getNotification();

      if (response) {
        this.notificationUpdatedSubject$.next(response);
      }

      return response;
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue while updating the notification data.',
      );
    }
  }
}
